import Vue from "vue";
import Vuex from "vuex";
import user from "./store/module/user";
import author from "./store/module/author";
import getters from "./store/getters";
Vue.use(Vuex);

export default new Vuex.Store({
  getters,
  modules: {
    user,
    author
  }
});
